import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import rolesStore from '../../../../../store/rolesStore';
import UserRoleInfo from './components/UserRoleInfo/UserRoleInfo';
import UserRolesListItem from './components/UserRolesListItem/UserRolesListItem';
import { localeStore } from 'src/mobx/localesStore';
import { LoadingStatus } from 'src/types/main';
import { emptyArray } from 'src/utils/helpers';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';

const UserRoles: React.FC = observer((): JSX.Element => {
  useEffect(() => {
    rolesStore.getRoles();
  }, []);

  return (
    <ScrollableBlock>
      <div className="d-flex full-width mt-4">
        <div className="w-20">
          {rolesStore.rolesLoadingStatus === LoadingStatus.Init || rolesStore.rolesLoadingStatus === LoadingStatus.Loading
            ? emptyArray(9).map((_, index) => (
                <Skeleton width={202} height={44} style={{ borderRadius: 30 }} key={`role-item-skeleton-${index}`} className="mb-2" />
              ))
            : rolesStore.roles.map((item) => (
                <UserRolesListItem
                  key={`role-item-${item.id}`}
                  title={localeStore.t(`${item.name}_role`)}
                  is_active={rolesStore.role?.id === item.id}
                  onPress={() => rolesStore.setActiveRole(item.id)}
                />
              ))}
        </div>
        <div className="w-80">
          <UserRoleInfo role={rolesStore.role} />
        </div>
      </div>
    </ScrollableBlock>
  );
});

export default UserRoles;
